import {Price} from './Price'

export const OrderSummary = ({order}) => {
  const {
    discount_total,
    order_total,
    tax_total,
    shipping_total,
    product_total,
    refund_total,
    // handling_total,
  } = order

  // console.log(
  //   discount_total,
  //   order_total,
  //   tax_total,
  //   shipping_total,
  //   product_total,
  //   refund_total,
  //   '$$',
  // )
  const rushProductionPrice = order?.order_metadata?.find(
    (meta) => meta.key === 'Rush Production Price',
  )?.value || '0';
  const normalizedRushProductionPrice =
    typeof rushProductionPrice === 'string'
      ? rushProductionPrice.trim()
      : rushProductionPrice
  const tipPrice = order?.order_metadata?.find(
    (meta) => meta.key === 'Tip Price',
  )?.value || '';
  const normalizedTipPrice =
    typeof tipPrice === 'string' ? tipPrice.trim() : tipPrice
  const shouldShowTipPrice =
    normalizedTipPrice !== '' &&
    normalizedTipPrice !== null &&
    normalizedTipPrice !== undefined
    
  const subtotal = (product_total + parseFloat(normalizedRushProductionPrice));
  const orderTotal = (order_total + parseFloat(normalizedRushProductionPrice));
  console.log(order)
  return (
    <div tw="mt-2 " className="mrt-0 text-gray">
      {product_total != 0 ? (
        <p tw="flex justify-between">
          <span>Subtotal</span>
          <Price>${subtotal.toFixed(2)}</Price>
        </p>
      ) : (
        <p tw="flex justify-between">
          <span>Subtotal</span>
          <Price>$0.00</Price>
        </p>
      )}
      {discount_total != 0 ? (
        <p tw="flex justify-between">
          <span>Discount</span>
          <Price>${discount_total.toFixed(2)}</Price>
        </p>
      ) : (
        <p tw="flex justify-between">
          <span>Discount</span>
          <Price>$0.00</Price>
        </p>
      )}
      {shipping_total != 0 ? (
        <p tw="flex justify-between">
          <span>Shipping</span>
          <Price>${shipping_total.toFixed(2)}</Price>
        </p>
      ) : (
        <p tw="flex justify-between">
          <span>Shipping</span>
          <Price>$0.00</Price>
        </p>
      )}
      {tax_total != 0 ? (
        <p tw="flex justify-between">
          <span>Taxes</span>
          <Price>${tax_total.toFixed(2)}</Price>
        </p>
      ) : (
        <p tw="flex justify-between">
          <span>Taxes</span>
          <Price>$0.00</Price>
        </p>
      )}
      {shouldShowTipPrice ? (
        <p tw="flex justify-between">
          <span>Tip</span>
          <Price>
            $
            {typeof normalizedTipPrice === 'number'
              ? normalizedTipPrice.toFixed(2)
              : normalizedTipPrice}
          </Price>
        </p>
      ) : null}
      {/* <p tw="flex justify-between">
        <span>Tip</span>
        <Price>${handling_total}</Price>
      </p> */}

      {refund_total !== 0 ? (
        <p tw="flex justify-between">
          <span>Refund</span>
          <Price>-${refund_total.toFixed(2)}</Price>
        </p>
      ) : (
        ''
      )}
      <p tw="flex justify-between font-semibold">
        <span className="text-brand">Total</span>
        <Price>${orderTotal.toFixed(2)}</Price>
      </p>
    </div>
  )
}
